import { render, staticRenderFns } from "./ArchivedPreprojects.vue?vue&type=template&id=5caa000c&scoped=true&"
import script from "./ArchivedPreprojects.vue?vue&type=script&lang=js&"
export * from "./ArchivedPreprojects.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedPreprojects.vue?vue&type=style&index=0&id=5caa000c&prod&lang=css&"
import style1 from "./ArchivedPreprojects.vue?vue&type=style&index=1&id=5caa000c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caa000c",
  null
  
)

export default component.exports